import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function WRXeomin() {
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px] overflow-hidden" data-id="element-2398">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-2399">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-2400">
          {/* Left Column - Text */}
          <AnimateOnScroll className="w-full lg:w-[55%]" data-id="element-2401">
            <span className="text-[#FF1493] uppercase text-[13px] font-bold tracking-[2px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-2402">
              TREATMENT OPTION
            </span>

            <h2 className="text-[26px] lg:text-[40px] uppercase text-black leading-tight mb-8 font-[600] font-[Poppins,_sans-serif]" data-id="element-2403">
              WHAT IS XEOMIN?
            </h2>

            <div className="space-y-6 text-[#333333] text-base leading-[1.8] font-body" data-id="element-2404">
              <p data-id="element-2405">
                Xeomin by Merz is a prescription medication that contains
                incobotulinumtoxinA, a type of botulinum toxin. Like Botox and
                Dysport, Xeomin is used for cosmetic purposes to treat moderate
                to severe frown lines between the eyebrows (glabellar lines) in
                adults. It is an injectable treatment that works by temporarily
                relaxing the muscles responsible for causing wrinkles, resulting
                in a smoother appearance of the skin.
              </p>
              <p data-id="element-2406">
                One notable feature of Xeomin is that it is a 'naked' or 'pure'
                form of botulinum toxin, meaning it lacks complexing proteins
                present in some other formulations. Its unique formula removes
                unnecessary proteins so the active ingredient contains only what
                is needed to smooth frown lines, treatment after treatment.
              </p>
            </div>
          </AnimateOnScroll>

          {/* Right Column - Image */}
          <AnimateOnScroll className="w-full lg:w-[45%]" delay={200} data-id="element-2407">
            <div className="relative w-full aspect-[3/4] rounded-lg overflow-hidden shadow-xl" data-id="element-2408">
              <img src="https://cdn.magicpatterns.com/uploads/tyiwEeg2B4ekT6X4zt6gUk/AdobeStock_257206406-4.webp" alt="Be CLINICAL Treatment Room - Xeomin" className="w-full h-full object-cover" data-id="element-2409" />
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}